export default __webpack_public_path__ + "static/media/ingredient_distribution_icon.ffa7c6ea.png";